import React from 'react';
import { View } from 'react-native';

import PropTypes from 'prop-types';

import {
  Icon,
  IconTypes,
  VFText,
  Toggle,
  VFButton,
} from '@vfgroup-oneplatform/foundation/Components';
import { LightThemeColors, withTheme } from '@vfgroup-oneplatform/foundation/Components/Themes';

import { Images } from '../../../Themes';

import styles from './AutoTopUpCard.Styles';

const getStatusDotImage = isActive => {
  if (isActive) {
    return Images.ic_green_circle;
  } else {
    return Images.ic_red_circle;
  }
};

function AutoTopUpCard({
  title,
  description,
  buttonTitle,
  onButtonPress,
  isAutoTopUpActivated,
  onToggleActiveStatus,
  theme,
}) {
  return (
    <View style={styles.containerStyle(theme)}>
      <View style={styles.titleContainer}>
        <View style={styles.titleLeftContainer}>
          <Icon
            type={IconTypes.image}
            name={getStatusDotImage(isAutoTopUpActivated)}
            size={17}
            style={styles.statusDotStyle}
          />
          <VFText i18nKey={title} style={styles.title} type="primary" />
        </View>
        <Toggle
          size="small"
          inactiveContainerStyle={styles.toggleStyle}
          initialValue={isAutoTopUpActivated}
          selected={isAutoTopUpActivated}
          onChange={onToggleActiveStatus}
        />
      </View>
      <VFText i18nKey={description} style={styles.description(isAutoTopUpActivated)} />
      <View style={styles.buttonsContainer}>
        <VFButton
          style={styles.buttonStyle}
          textStyle={styles.textButtonStyle}
          title={buttonTitle}
          onPress={onButtonPress}
          type="secondary"
        />
      </View>
    </View>
  );
}

AutoTopUpCard.defaultProps = {
  theme: LightThemeColors,
};

AutoTopUpCard.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  buttonTitle: PropTypes.string.isRequired,
  onButtonPress: PropTypes.func,
  isAutoTopUpActivated: PropTypes.bool,
  onToggleActiveStatus: PropTypes.func,
  theme: PropTypes.shape({
    name: PropTypes.string,
    isDark: PropTypes.bool,
    colors: PropTypes.object,
  }),
};

export default withTheme(AutoTopUpCard);
